import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface EditIconProps extends SvgIconProps {}

export const EditIcon = (props: EditIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} {...props} viewBox="0 0 22.746 18.88">
      <g transform="translate(-3.5 -3.318)">
        <path
          d="M18,30H31.5"
          transform="translate(-6.254 -8.802)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M17.454,4.931a2,2,0,0,1,2.879,0,2.132,2.132,0,0,1,0,2.958L8.338,20.212,4.5,21.2l.96-3.944Z"
          transform="translate(0 0)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </SvgIcon>
  );
};
